<template>
    <div>
        <card-header title="Tasks" :subheader="queue.name" icon="fa-tasks"/>
        <card-body>
            <card-list>
                <subheader-list-item title="Trip Tasks" icon="fa-tennis-ball" :badge="queue.trip + queue.trip_events + queue.trip_addons + queue.trip_hotels"/>

                <task-navigation-list-item
                    title="Trips"
                    icon="fa-tennis-ball"
                    :tasks="queue.trip"
                    :active="detailsActive('trip')"
                    @click="$openCard('task-details', {type: 'trip', assignee: props.assigneeId}, card)"
                />
                <task-navigation-list-item
                    title="Events"
                    icon="fa-users"
                    :tasks="queue.trip_events"
                    :active="detailsActive('trip-events')"
                    @click="$openCard('task-details', {type: 'trip-events', assignee: props.assigneeId}, card)"
                />
                <task-navigation-list-item
                    title="Add-Ons"
                    icon="fa-layer-plus"
                    :tasks="queue.trip_addons"
                    :active="detailsActive('trip-addons')"
                    @click="$openCard('task-details', {type: 'trip-addons', assignee: props.assigneeId}, card)"
                />
                <task-navigation-list-item
                    title="Hotels"
                    icon="fa-hotel"
                    :tasks="queue.trip_hotels"
                    :active="detailsActive('trip-hotels')"
                    @click="$openCard('task-details', {type: 'trip-hotels', assignee: props.assigneeId}, card)"
                />

                <subheader-list-item title="Registration Tasks" icon="fa-suitcase-rolling" :badge="queue.registration + queue.flights + queue.reg_hotels + queue.reg_events + queue.reg_addons"/>

                <task-navigation-list-item
                    title="Registrations"
                    icon="fa-suitcase"
                    :tasks="queue.registration"
                    :active="detailsActive('registration')"
                    @click="$openCard('task-details', {type: 'registration', assignee: props.assigneeId}, card)"
                />
                <task-navigation-list-item
                    title="Flights"
                    icon="fa-plane"
                    :tasks="queue.flights"
                    :active="detailsActive('flights')"
                    @click="$openCard('task-details', {type: 'flights', assignee: props.assigneeId}, card)"
                />
                <task-navigation-list-item
                    title="Hotels"
                    icon="fa-hotel"
                    :tasks="queue.reg_hotels"
                    :active="detailsActive('reg-hotels')"
                    @click="$openCard('task-details', {type: 'reg-hotels', assignee: props.assigneeId}, card)"
                />
                <task-navigation-list-item
                    title="Events"
                    icon="fa-users"
                    :tasks="queue.reg_events"
                    :active="detailsActive('reg-events')"
                    @click="$openCard('task-details', {type: 'reg-events', assignee: props.assigneeId}, card)"
                />
                <task-navigation-list-item
                    title="Add-Ons"
                    icon="fa-layer-plus"
                    :tasks="queue.reg_addons"
                    :active="detailsActive('reg-addons')"
                    @click="$openCard('task-details', {type: 'reg-addons', assignee: props.assigneeId}, card)"
                />

                <subheader-list-item title="Other Tasks" icon="fa-clipboard-check" :badge="queue.customer + queue.lead + queue.contact"/>

                <task-navigation-list-item
                    title="Customers"
                    icon="fa-user"
                    :tasks="queue.customer"
                    :active="detailsActive('customer')"
                    @click="$openCard('task-details', {type: 'customer', assignee: props.assigneeId}, card)"
                />
                <task-navigation-list-item
                    title="Leads"
                    icon="fa-address-card"
                    :tasks="queue.lead"
                    :active="detailsActive('lead')"
                    @click="$openCard('task-details', {type: 'lead', assignee: props.assigneeId}, card)"
                />
                <task-navigation-list-item
                    title="Contacts"
                    icon="fa-address-book"
                    :tasks="queue.contact"
                    :active="detailsActive('contact')"
                    @click="$openCard('task-details', {type: 'contact', assignee: props.assigneeId}, card)"
                />
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "../../TIER/components/CardHeader";
    import CardList from "../../TIER/components/CardList";
    import CardBody from "../../TIER/components/CardBody";
    import SubheaderListItem from "../../TIER/components/SubheaderListItem";
    import TaskNavigationListItem from "@/components/TaskNavigationListItem";
    import {mapActions, mapGetters} from 'vuex';

    // One staff member's task queue (or the unassigned pool), same layout as
    // your own queue on the Tasks card. Counts come from tasks.byAssignee in
    // the store; the drill-down lists come from /api/tasks/:type?assignee=.
    export default {
        props: ['card', 'child', 'props'],
        components: {TaskNavigationListItem, SubheaderListItem, CardBody, CardList, CardHeader},
        computed: {
            ...mapGetters(['tasks']),
            queue() {
                const match = (this.tasks.byAssignee || []).find(q =>
                    (this.props.assigneeId === 'unassigned') ? q.id === null : String(q.id) === String(this.props.assigneeId)
                );
                return match || {name: '', trip: 0, registration: 0, flights: 0, reg_hotels: 0, reg_events: 0, reg_addons: 0, trip_events: 0, trip_addons: 0, trip_hotels: 0, customer: 0, lead: 0, contact: 0, total: 0};
            }
        },
        methods: {
            ...mapActions(['updateTasks']),
            detailsActive(type) {
                return !!(this.child && this.child.definition.component === 'task-details'
                    && this.child.props.type === type
                    && String(this.child.props.assignee) === String(this.props.assigneeId));
            },
            reload() {
                this.$emit('loading', true);
                this.updateTasks().then(() => {
                    this.$emit('loading', false);
                });
            }
        },
        mounted() {
            this.$emit('title', this.queue.name);
            this.reload();
        },
        watch: {
            'props.assigneeId': function () {
                this.$emit('title', this.queue.name);
            }
        }
    };
</script>

<style lang="scss" scoped>

</style>
